module.exports = __webpack_public_path__ + "img/shoot_00019.cab3bfcb.png";